import $ from 'jquery';
import _ from 'underscore';
import SliderRange from 'blocks/slider-range/slider-range';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaInternetTariff',
			dom: {
				hour: '#yotaInternetTariffHour',
				year: '#yotaInternetTariffYear',
				sliderRange: '.js-slider-range',
				templateTabs: '.js-internet-tariff-template-tabs',
				templateHour: '.js-internet-tariff-template-hour',
				templateYear: '.js-internet-tariff-template-year',
				tabs: '.js-internet-tariff-tabs',
				tab: '.js-internet-tariff-tabs .js-tab',
				actionPrice: '.js-internet-tariff-action-price',
				price: '.js-internet-tariff-price',
				time: '.js-internet-tariff-time',
				speed: '.js-internet-tariff-speed',
				speedMax: '.js-internet-tariff-speed-max',
				speedUnit: '.js-internet-tariff-speed-unit'
			},
			classes: {
				state: {
					years: 'b-internet-tariff_state_years',
					hours: 'b-internet-tariff_state_hours',
					action: 'b-internet-tariff_state_action'
				}
			},
			data: {}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.rate = false;
		this.activated = false;
		this.$el = $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$hour = this.$el.find(this.options.dom.hour);
		this.$year = this.$el.find(this.options.dom.year);
		this.$sliderRange = this.$el.find(this.options.dom.sliderRange);
		this.$templateTabs = this.$el.find(this.options.dom.templateTabs);
		this.templateTabs = _.template(this.$templateTabs.html().trim());
		this.$templateHour = this.$el.find(this.options.dom.templateHour);
		this.templateHour = _.template(this.$templateHour.html().trim());
		this.$templateYear = this.$el.find(this.options.dom.templateYear);
		this.templateYear = _.template(this.$templateYear.html().trim());
		this.$tabs = this.$el.find(this.options.dom.tabs);
		this.$tab = this.$el.find(this.options.dom.tab);
		this.$actionPrice = this.$el.find(this.options.dom.actionPrice);
		this.$price = this.$el.find(this.options.dom.price);
		this.$time = this.$el.find(this.options.dom.time);
		this.$speed = this.$el.find(this.options.dom.speed);
		this.$speedMax = this.$el.find(this.options.dom.speedMax);
		this.$speedUnit = this.$el.find(this.options.dom.speedUnit);
		return this;
	}

	setTabs() {
		const html = this.templateTabs({items: [this.data.turbo_rates]});
		const hour = this.templateHour(this.data.turbo_rates);
		const year = this.templateYear({items: this.data.year_rates});
		console.log({items: [this.data.year_rates]});
		this.$tabs.append(html);
		this.$hour.html(hour);
		this.$year.html(year);
		this.$tab = this.$el.find(this.options.dom.tab);
	}

	setInfo(data) {
		this.$el.toggleClass(this.options.classes.state.action, data.action !== false);
		this.$actionPrice.text(data.action === false ? '' : data.action);
		this.$price.text(data.price);

		if (this.data.internet_rates[this.data.internet_rates.length - 1].speed == data.speed) {
			data.speed = this.$speedMax.data('max');
			data.speedUnit = '';
		}

		if (data.speedUnit != '') {
			this.$speed.text(data.speed);
			this.$speedMax.text('');
			this.$speedUnit.text(data.speedUnit);
		} else {
			this.$speed.text('');
			this.$speedUnit.text('');
			this.$speedMax.text(data.speed);
		}
	}

	getActiveAncor(ancor) {
		const action = ancor;
		let selected = false;
		_.each(this.data.turbo_rates, function (item) {
			if (item.ancor == action) {
				selected = item;
			}
		});
		return selected;
	}

	onTabChange() {
		const active = this.$tab.filter(':checked').data('js');
		this.$el.toggleClass(this.options.classes.state.hours, active == 'hour');
		this.$el.toggleClass(this.options.classes.state.years, active == 'year');
		if (active !== 'month') {
			this.$el.data('params', [active]);
		} else {
			this.$time.text(this.$time.data(active));
			this.setInfo(this.rate);
			this.$el.data('params', [active, this.rate.ancor]);
		}

		this.$window.trigger('yota.router.check');
	}

	onSlide(position, rate) {
		const active = this.$tab.filter(':checked').data('js');
		rate.action = rate.action || false;
		this.rate = rate;
		this.setInfo(this.rate);
		this.$el.data('params', [active, this.rate.ancor]);
		this.$window.trigger('yota.router.check');
	}

	update() {
		const params = this.$el.data('params') || [];
		if (params.length) {
			const $tab = this.$tab.filter('[data-js="' + params[0] + '"]');
			if ($tab.length) {
				this.$tab.not($tab).prop('checked', false);
				$tab.prop('checked', true);
			}
			if (params[0] == 'month' && params.length > 1) {
				this.data.internet_base_rate = this.sliderRange.getRate(params[1], 'ancor').rate.price;
				this.sliderRange.update({base: this.data.internet_base_rate});
			}

		}
	}

	activate() {
		const self = this;
		if (!self.activated && self.$el.data('activated') === true) {
			self.activated = true;
			setTimeout(function () {
				self.sliderRange.animate();
			}, 100);
		}
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.internetTariff) {
				this.data = yotaPortlets.internetTariff;
				this.getDom();
				this.setTabs();

				this.sliderRange = new SliderRange({
					el: this.$sliderRange,
					base: this.data.internet_base_rate,
					rates: this.data.internet_rates,
					callback: {
						update: this.onSlide.bind(this)
					}
				});
				this.$el
					.on('yota.router.update', this.update.bind(this))
					.on('yota.router.activate', this.activate.bind(this))
					.trigger('yota.router.update');

				this.sliderRange.render();

				this.$tab.on('change click', this.onTabChange.bind(this)).trigger('change');

				this.$el.trigger('yota.router.activate');

			} else {
				console.error('The internetTariff portlet has no data, set data to "yotaPortlets.internetTariff"');
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/internet-tariff/internet-tariff.js